export const elementTouch = (e: HTMLElement) => {
  //this is to remove uncatchable oferflow in registration flow
  if ('ontouchstart' in window || 'ontouchend' in document) {
    e.dispatchEvent(new Event('touchstart', { bubbles: true }))
    e.dispatchEvent(new Event('touchend', { bubbles: true }))
  }
}